import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import alertify from 'alertifyjs';

import { setHourglassState } from '../../redux/actions/hourglassAction';

/**
 * Implementation extracted from RightPanel.js as it will be reused in 
 * MobileView Footer
 */
export const useAddToCart = (setCartEnabled:(state:boolean)=>void) => {
    const makFabric = useSelector((state: any) => state.makFabric)
    const product2d = useSelector((state: any) => state.product2d)
    const product2dCanvasState = useSelector((state: any) => state.product2dCanvasState)

    const dispatch = useDispatch();

    const [contState, setContState] = useState([] as any[])
    const [price, setPrice] = useState('0')

    useEffect(() => {
        if (product2d && makFabric) {
            makFabric.help.addToCartDisabled = setContState
        }
    }, [makFabric, product2d])

    useEffect(() => {
        if (contState) {
            const url =
                window.location !== window.parent.location
                    ? document.referrer
                    : document.location.origin

            let data = { action: "APP_CHANGES" }

            let arr = contState.map(item => [...item.payload]).flat()
            if (arr.length) {
                setCartEnabled(true)
                window.parent.postMessage(JSON.stringify({ ...data, type: true }), url)
            } else {
                setCartEnabled(false)
                window.parent.postMessage(JSON.stringify({ ...data, type: false }), url)
            }
        }
    }, [contState, setCartEnabled])

    useEffect(() => {
        if (product2d) {
            if (contState) {
                console.log()
                let f = contState.filter(i => i.payload.length)

                if (f.length && product2d.partPrice) {
                    setPrice(
                        (
                            parseFloat(product2d.price) +
                            (f.length - 1) * parseFloat(product2d.partPrice)
                        ).toFixed(2),
                    )
                } else {
                    setPrice(parseFloat(product2d.price).toFixed(2))
                }
            } else {
                setPrice(parseFloat(product2d.price).toFixed(2))
            }
        }
    }, [contState, product2d])


    const addToCart = useCallback(
        (e: any) => {
            e.preventDefault()
            dispatch(setHourglassState(true))

            const url =
                window.location !== window.parent.location
                    ? document.referrer
                    : document.location.origin

            let cp = contState.filter((i: any) => i.payload.length) as any

            makFabric.addToCart(
                product2dCanvasState,
                (e: any) => {
                    console.log(e.final)
                    let data = {
                        action: "addToCartAction",
                        content: e.metadata,
                        screenshot: e.final.side.map((i: any) => ({
                            name: i.name,
                            img: i.screenShot,
                        })),
                        // name: product2d.name,
                        price: price,
                        size: product2d.size,
                        sku: product2d.variationSKU,
                        garmetId: product2d.id,
                        customizebleParts: cp && cp.length ? parseInt(cp.length) : 0,
                    }

                    if (!e.metadata) {
                        alertify.error("Can't save the data")
                    } else {
                        window.parent.postMessage(JSON.stringify(data), url)
                    }

                    dispatch(setHourglassState(false))
                },
                { sku: product2d.sku },
            )
        },
        [
            contState,
            dispatch,
            makFabric,
            price,
            product2d.id,
            product2d.size,
            product2d.variationSKU,
            product2dCanvasState,
        ],
    )

    return addToCart
}